module.exports = __webpack_public_path__ + "img/99.96d9aa86.jpg";